<template>
  <div class="page text_center" v-loading="loading">
    <span @click="logout" class="logout">退出登录</span>
    <h1>NETCLASS英语作文智能批改系统（学生端）</h1>
    <div class="flex space_around">
      <p>
        学校：{{ user.sys_school_name }}
        <span style="padding-left: 20px">班级：{{ user.sys_class_name }}</span>
      </p>
      <p>
        学员：{{ user.mem_name }}
        <span style="padding-left: 20px">编号：{{ user.mem_nbnumber }}</span>
      </p>
    </div>
    <hr />
    <div class="menu flex align_center space_center">
      我的作文：
      <p
        :class="activeIndex == '已提交' ? 'active' : ''"
        style="margin: 0 30px 0 10px"
        @click="handleSelect('已提交')"
      >
        已提交（{{ total_work }}）
      </p>
      <p
        :class="activeIndex == '待完成作文' ? 'active' : ''"
        @click="handleSelect('待完成作文')"
      >
        待完成作文（{{ total_job }}）
      </p>
    </div>

    <br />
    <br />

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{
        'text-align': 'center',
        background: '',
      }"
    >
      <el-table-column type="index" label="NO" align="center" />
      <el-table-column
        prop="title"
        label="标题"
        show-overflow-tooltip
        align="center"
        width="400"
      />
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        v-if="activeIndex == '已提交'"
      >
        <template #default="scope">
          <el-link type="success" v-if="scope.row.status == 0"
            >批改完成</el-link
          >
          <el-link type="warning" v-if="scope.row.status == 1">批改中</el-link>
          <el-link type="primary" v-if="scope.row.status == 2">待批改</el-link>
          <el-link type="danger" v-if="scope.row.status == 3">失败</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="分类" align="center">
        <template #default="scope">
          <el-link type="warning" v-if="scope.row.type == 0">通用</el-link>
          <el-link type="primary" v-if="scope.row.type == 1">雅思</el-link>
          <el-link type="success" v-if="scope.row.type == 2">托福</el-link>
        </template>
      </el-table-column>

      <el-table-column
        prop="totalscore"
        label="得分"
        align="center"
        v-if="activeIndex == '已提交'"
      />
      <el-table-column
        prop="updated_at"
        label="提交日期"
        align="center"
        v-if="activeIndex == '已提交'"
        width="200"
      />
      <el-table-column
        prop="teacher_name"
        label="老师"
        align="center"
        v-if="activeIndex == '待完成作文'"
      />
      <el-table-column
        prop="updated_at"
        label="作文布置日期"
        align="center"
        v-if="activeIndex == '待完成作文'"
      />

      <el-table-column prop="" label="详情" align="center">
        <template #default="scope">
          <el-button
            text
            type="success"
            @click="showReport(scope.row)"
            v-if="activeIndex == '已提交' && scope.row.status == 0"
            >查看</el-button
          >
          <el-button
            text
            type="success"
            @click="handleSubmit(scope.row)"
            v-if="activeIndex == '待完成作文'"
            >提交作文</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <Pagination @pageChange="pageChangeFn" :total="total"></Pagination>
    <el-dialog v-model="dialogShow" title="" width="50%">
      <el-form ref="formRef" :model="form" label-width="130px">
        <el-form-item label="作文标题">
          <div class="text_left">{{ title }}</div>
        </el-form-item>

        <el-form-item
          label="作文"
          prop="content"
          :rules="[
            {
              required: true,
              message: '请输入作文',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            type="textarea"
            :rows="14"
            v-model="form.content"
            placeholder="请输入作文（限1000个单词）"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogShow = false">取消</el-button>
          <el-button
            color="#27ae60"
            @click="onSubmit(formRef)"
            :loading="btn_loading"
          >
            提交
          </el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog v-model="reportShow" title="" width="60%">
      <div v-loading="report_loading">
        <Report :reportData="reportData"></Report>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { reactive, ref, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'

import Pagination from '../../components/Pagination'
import Report from '../../components/Report'
import { getList, handleAdd, getUserInfo, getUser } from '../../request/home'
export default {
  components: { Pagination, Report },
  setup() {
    const formRef = ref()
    const router = useRouter()
    const state = reactive({
      search: {
        page: 1,
      },
      form: {},
      tableData: [],
      dialogShow: false,
      loading: false,
      btn_loading: false,
      total: 0,
      activeIndex: '已提交',
      reportShow: false,
      user: {},
      total_job: 0,
      total_work: 0,
      title: '',
      reportData: {},
      report_loading: false,
    })
    onMounted(() => {
      getuser()
      setInterval(() => {
        setTimeout(() => {
          init()
        }, 0)
      }, 60000)
    })

    const init = async () => {
      // state.loading = true
      state.search.class_id = state.user.sys_class_id
      const { data, code, msg, total, total_job, total_work } = await getList(
        state.search
      )
      // state.loading = false
      if (code == 200) {
        state.tableData = data
        state.total = total
        state.total_job = total_job
        state.total_work = total_work
      } else {
        ElMessage.error(msg)
        return
      }
    }
    const getuser = async () => {
      state.loading = true
      const { data, code, msg, total } = await getUser()
      state.loading = false
      if (code == 200) {
        state.user = data.data
        init()
      } else {
        ElMessage.error(msg)
        return
      }
    }
    const getInfo = async id => {
      state.report_loading = true
      const { data, code, msg, total } = await getUserInfo({ id: id })
      state.report_loading = false
      if (code == 200) {
        state.reportData = data
        state.reportData.score = JSON.parse(data.score)
        state.reportData.check = JSON.parse(data.check)
        state.reportData.optimize = data.optimize
          ? JSON.parse(data.optimize)
          : []
      } else {
        ElMessage.error(msg)
        return
      }
    }

    const onSearch = () => {
      state.search.page = 1
      init()
    }

    const pageChangeFn = value => {
      state.search.page = value
      init()
    }
    const create = () => {
      state.dialogShow = true
      state.form = {}
    }
    const onSubmit = async (a, b) => {
      let length = state.form.content.split(/\s+/)
      console.log(length.length)
      if (length.length < 30) {
        ElMessage.error('作文过于简短，系统不支持批改！')
        return false
      }
      if (length.length > 1000) {
        ElMessage.error('不可超过1000个单词')
        return false
      }
      if (!formRef) return
      formRef.value.validate(valid => {
        if (valid) {
          state.btn_loading = true
          confirm()
        }
      })
    }
    const confirm = async () => {
      state.form.class_id = state.user.sys_class_id
      const { data, code, msg } = await handleAdd(state.form)
      state.btn_loading = false
      if (code == 200) {
        ElMessage.success('老师批阅大概需要2分钟,请稍后刷新查看批改报告')
        state.dialogShow = false
        init()
      } else {
        ElMessage.error(msg)
        return
      }
    }

    const handleSelect = async e => {
      state.activeIndex = e
      if (e == '待完成作文') {
        state.search.type = 1
      } else {
        state.search.type = ''
      }
      state.page = 1
      init()
    }
    const showReport = async e => {
      state.reportShow = true
      getInfo(e.id)
    }
    const handleSubmit = async e => {
      state.form.job_id = e.job_id
      state.title = e.title
      state.dialogShow = true
    }
    const logout = () => {
      ElMessageBox.confirm('确认要退出吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        localStorage.removeItem('student')
        localStorage.removeItem('student_token')
        router.push({
          name: 'Login',
          params: { gid: localStorage.getItem('s_catalog') },
        })
        localStorage.removeItem('s_catalog')
      })
    }
    return {
      ...toRefs(state),
      formRef,
      init,
      onSearch,
      onSubmit,
      create,
      pageChangeFn,
      handleSelect,
      showReport,
      getInfo,
      getuser,
      handleSubmit,
      logout,
    }
  },
}
</script>

<style lang="less" scoped>
.page {
  width: 80%;
  margin: auto;
  padding: 40px;
}
h1 {
  color: #27ae60;
}
hr {
  background-color: #27ae60;
  height: 1px;
  border: none;
}

.menu {
  p {
    cursor: pointer;
  }
}
.active {
  border-bottom: 2px solid #27ae60;
  padding-bottom: 2px;
  font-weight: 700;
  color: #27ae60;
}
.logout {
  color: #27ae60;
  float: right !important;
  cursor: pointer;
}
</style>
